import {
  CnpjFormField,
  CpfFormField,
  FloatingFormItem,
} from '@/components/_common';
import { useCreateAuthorizationDownloadXml } from '@/core/domain/invoice/settings/Settings.hooks';
import {
  AuthorizationDownloadXmlRequestDTO,
  selectCpfCnpjEnum,
} from '@/core/domain/invoice/settings/Settings.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Input, Modal, Radio, Row } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import { useIntl } from 'react-intl';

interface Props {
  modalVisible: boolean;
  invoiceSettingsId?: number;
  modalVisibleAction: () => void;
  form: FormInstance<AuthorizationDownloadXmlRequestDTO>;
}

const AuthorizationDownloadXmlModal = ({
  form,
  modalVisible,
  invoiceSettingsId,
  modalVisibleAction,
}: Props) => {
  const intl = useIntl().formatMessage;
  const requiredRule = useDefaultEmptyFieldError();

  const selectCpfCnpjWatch = Form.useWatch('selectCpfCnpj', form);

  const authorizationCreate = useCreateAuthorizationDownloadXml();

  async function handleSubmit() {
    try {
      const values = await form.validateFields();

      if (invoiceSettingsId) {
        await authorizationCreate.mutateAsync({
          ...values,
          invoiceSettingsId: invoiceSettingsId,
        });
      }

      modalVisibleAction();
    } catch {}
  }

  return (
    <Modal
      destroyOnClose
      onOk={handleSubmit}
      open={modalVisible}
      title="Autorização para baixar xml"
      onCancel={() => {
        modalVisibleAction();
      }}
    >
      <Form preserve={false} form={form}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <FloatingFormItem
              name="selectCpfCnpj"
              initialValue={selectCpfCnpjEnum.cpf}
            >
              <Radio.Group>
                <Radio value={selectCpfCnpjEnum.cpf}>CPF</Radio>
                <Radio value={selectCpfCnpjEnum.cnpj}>CNPJ</Radio>
              </Radio.Group>
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            {selectCpfCnpjWatch === selectCpfCnpjEnum.cpf ? (
              <CpfFormField fieldName="cpfCnpj" />
            ) : (
              <CnpjFormField fieldName="cpfCnpj" />
            )}
          </Col>

          <Col>
            <FloatingFormItem
              label="Email"
              name="email"
              rules={[
                {
                  type: 'email',
                  message: intl({
                    id: 'commons.form.errors.invalidEmail',
                  }),
                },
                requiredRule,
              ]}
            >
              <Input />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AuthorizationDownloadXmlModal;
